import { toCurrencyTruncated } from '@/utilities/formatting';
import { Grid, Text } from '@simplywallst/ui-core';
import { Banding } from './Banding';

type Props = {
  fairValue: number | undefined | null;
  intrinsicDiscount: number | undefined | null;
  currencyISO: string;
};

export const ValuationFairValue = ({
  fairValue,
  intrinsicDiscount,
  currencyISO,
}: Props) => {
  return (
    <Grid justifyContent="flex-end">
      {fairValue ? (
        <>
          {typeof fairValue === 'number' && (
            <Text color="textSolid" typography="small" textAlign="end">
              {toCurrencyTruncated(fairValue, 2, currencyISO)}
            </Text>
          )}
          {typeof intrinsicDiscount === 'number' && (
            <Banding value={intrinsicDiscount} />
          )}
        </>
      ) : (
        <Text color="textSolid" typography="small" textAlign="end">
          N/A
        </Text>
      )}
    </Grid>
  );
};
